import React, { Component } from 'react';
import moment from 'moment';
import { getStartEndTime } from '../../../utils/timeUtil';
import 'react-dropdown-tree-select/dist/styles.css';
import 'react-nice-dates/build/style.css';
import './Header.scss';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import actions from '../../../store/appActions';

// var typingTimer;

const appStyles = {
  fontFamily: 'sans-serif',
  textAlign: 'center'
};

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: props.searchQuery || '',
      standardTimeValue: '0',
      min: null,
      max: null,
      rangedTimeStart: null,
      rangedTimeEnd: null,
      timeType: 0,
      startValid: true,
      endValid: true,
      startBeforeEnd: true,
      dayStart: '',
      monthStart: '',
      inputMonthStart: '',
      yearStart: '',
      dayEnd: '',
      monthEnd: '',
      inputMonthEnd: '',
      yearEnd: ''
    };
  }

  async componentDidMount() {
    let startMod = moment()
      .startOf('day')
      .format('YYYY-MM-DD');
    let endMod = moment()
      .startOf('day')
      .format('YYYY-MM-DD');

    let start = moment().format('YYYY-MM-DD');
    let end = moment()
      .add(1, 'days')
      .format('YYYY-MM-DD');

    let timeObject = getStartEndTime(this.state.standardTimeValue);
    start = timeObject.start;
    end = timeObject.end;

    await this.setState({
      min: startMod,
      max: endMod
    });

    await this.props.setStartEnd(start, end);
    this.setRangedTimePeriod(this.state.min, this.state.max, false);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetVersion !== this.props.resetVersion) {
      const today = moment()
        .startOf('day')
        .format('YYYY-MM-DD');
      this.setState({
        searchTerm: '',
        standardTimeValue: '0',
        timeType: 0
      });
      this.setRangedTimePeriod(today, today, false);
    }

    if (
      prevProps.searchQuery !== this.props.searchQuery &&
      this.props.searchQuery !== this.state.searchTerm
    ) {
      this.setState({ searchTerm: this.props.searchQuery || '' });
    }

    if (
      prevProps.queryStart !== this.props.queryStart ||
      prevProps.queryEnd !== this.props.queryEnd
    ) {
      const { queryStart, queryEnd } = this.props;
      if (queryStart && queryEnd) {
        const newStart = moment(queryStart).format('YYYY-MM-DD');
        const newEnd = moment(queryEnd)
          .subtract(1, 'days')
          .format('YYYY-MM-DD');
        if (newStart !== this.state.min || newEnd !== this.state.max) {
          this.setState({ timeType: 1 });
          this.setRangedTimePeriod(newStart, newEnd, false);
        }
      }
    }
  }

  changeTimeType = async timeType => {
    await this.setState({ timeType: timeType });
  };

  fromDay = async e => {
    let value = parseInt(e.target.value);
    if (value > 31) value = 31;
    await this.setState({ dayStart: value });
    if (
      moment(
        {
          year: this.state.yearStart,
          month: this.state.monthStart,
          day: this.state.dayStart
        },
        true
      ).isValid() &&
      this.state.yearStart !== '' &&
      this.state.monthStart !== '' &&
      this.state.dayStart !== ''
    ) {
      let startBeforeEndBool = moment({
        year: this.state.yearStart,
        month: this.state.monthStart,
        day: this.state.dayStart
      }).isSameOrBefore(
        moment({
          year: this.state.yearEnd,
          month: this.state.monthEnd,
          day: this.state.dayEnd
        }),
        'day'
      );
      this.setState({ startValid: true, startBeforeEnd: startBeforeEndBool });
      this.setStartDate();
    } else {
      this.setState({ startValid: false });
    }
  };

  fromMonth = async e => {
    let value = parseInt(e.target.value);
    if (value > 12) value = 12;
    await this.setState({ inputMonthStart: value, monthStart: value - 1 });
    if (
      moment(
        {
          year: this.state.yearStart,
          month: this.state.monthStart,
          day: this.state.dayStart
        },
        true
      ).isValid() &&
      this.state.yearStart !== '' &&
      this.state.monthStart !== '' &&
      this.state.dayStart !== ''
    ) {
      let startBeforeEndBool = moment({
        year: this.state.yearStart,
        month: this.state.monthStart,
        day: this.state.dayStart
      }).isSameOrBefore(
        moment({
          year: this.state.yearEnd,
          month: this.state.monthEnd,
          day: this.state.dayEnd
        }),
        'day'
      );
      this.setState({ startValid: true, startBeforeEnd: startBeforeEndBool });
      this.setStartDate();
    } else {
      this.setState({ startValid: false });
    }
  };

  fromYear = async e => {
    let value = parseInt(e.target.value);
    await this.setState({ yearStart: value });
    if (
      moment(
        {
          year: this.state.yearStart,
          month: this.state.monthStart,
          day: this.state.dayStart
        },
        true
      ).isValid() &&
      this.state.yearStart !== '' &&
      this.state.monthStart !== '' &&
      this.state.dayStart !== ''
    ) {
      let startBeforeEndBool = moment({
        year: this.state.yearStart,
        month: this.state.monthStart,
        day: this.state.dayStart
      }).isSameOrBefore(
        moment({
          year: this.state.yearEnd,
          month: this.state.monthEnd,
          day: this.state.dayEnd
        }),
        'day'
      );
      this.setState({ startValid: true, startBeforeEnd: startBeforeEndBool });
      this.setStartDate();
    } else {
      this.setState({ startValid: false });
    }
  };

  toDay = async e => {
    let value = parseInt(e.target.value);
    if (value > 31) value = 31;
    await this.setState({ dayEnd: value });
    if (
      moment(
        {
          year: this.state.yearEnd,
          month: this.state.monthEnd,
          day: this.state.dayEnd
        },
        true
      ).isValid() &&
      this.state.yearEnd !== '' &&
      this.state.monthEnd !== '' &&
      this.state.dayEnd !== ''
    ) {
      let startBeforeEndBool = moment({
        year: this.state.yearStart,
        month: this.state.monthStart,
        day: this.state.dayStart
      }).isSameOrBefore(
        moment({
          year: this.state.yearEnd,
          month: this.state.monthEnd,
          day: this.state.dayEnd
        }),
        'day'
      );
      this.setState({ endValid: true, startBeforeEnd: startBeforeEndBool });
      this.setEndDate();
    } else {
      this.setState({ endValid: false });
    }
  };

  toMonth = async e => {
    let value = parseInt(e.target.value);
    if (value > 12) value = 12;
    await this.setState({ inputMonthEnd: value, monthEnd: value - 1 });
    if (
      moment(
        {
          year: this.state.yearEnd,
          month: this.state.monthEnd,
          day: this.state.dayEnd
        },
        true
      ).isValid() &&
      this.state.yearEnd !== '' &&
      this.state.monthEnd !== '' &&
      this.state.dayEnd !== ''
    ) {
      let startBeforeEndBool = moment({
        year: this.state.yearStart,
        month: this.state.monthStart,
        day: this.state.dayStart
      }).isSameOrBefore(
        moment({
          year: this.state.yearEnd,
          month: this.state.monthEnd,
          day: this.state.dayEnd
        }),
        'day'
      );
      this.setState({ endValid: true, startBeforeEnd: startBeforeEndBool });
      this.setEndDate();
    } else {
      this.setState({ endValid: false });
    }
  };

  toYear = async e => {
    let value = parseInt(e.target.value);
    await this.setState({ yearEnd: value });
    if (
      moment(
        {
          year: this.state.yearEnd,
          month: this.state.monthEnd,
          day: this.state.dayEnd
        },
        true
      ).isValid() &&
      this.state.yearEnd !== '' &&
      this.state.monthEnd !== '' &&
      this.state.dayEnd !== ''
    ) {
      let startBeforeEndBool = moment({
        year: this.state.yearStart,
        month: this.state.monthStart,
        day: this.state.dayStart
      }).isSameOrBefore(
        moment({
          year: this.state.yearEnd,
          month: this.state.monthEnd,
          day: this.state.dayEnd
        }),
        'day'
      );
      this.setState({ endValid: true, startBeforeEnd: startBeforeEndBool });
      this.setEndDate();
    } else {
      this.setState({ endValid: false });
    }
  };

  search = e => {
    this.setState({ searchTerm: e });
    this.props.clearSelectedItem();
    this.props.clearEntireTrack();
    this.props.setSearchQuery(e);
    this.props.fetchAllData();
  };

  setFixedTimePeriod = event => {
    const value = String(event);
    // Set to local state and local storage
    this.setState({ standardTimeValue: value, timeType: 0 });
    let timeObject = getStartEndTime(value);

    const normalizedStart = moment(timeObject.start).format('YYYY-MM-DD');
    const normalizedEnd = moment(timeObject.end).format('YYYY-MM-DD');
    const periodChanged =
      normalizedStart !== this.props.queryStart ||
      normalizedEnd !== this.props.queryEnd;
    if (periodChanged) {
      this.props.clearSelectedItem();
      this.props.clearEntireTrack();
      this.props.setStartEnd(normalizedStart, normalizedEnd);
      if (this.props.fetchAllData && this.props.fetchAllData.cancel) {
        this.props.fetchAllData.cancel();
      }
      this.props.fetchAllData({ refreshAlerts: true });
    }

    this.setRangedTimePeriod(
      timeObject.start,
      moment(timeObject.end)
        .add(-1, 'days')
        .format('YYYY-MM-DD'),
      false
    );
  };

  setRangedTimePeriod = (start, end, makeCall) => {
    let localStart = start;
    let localEnd = end;
    const normalizedStart = moment(localStart).format('YYYY-MM-DD');
    const normalizedEnd = moment(localEnd).format('YYYY-MM-DD');
    let startBeforeEndBool = moment(localStart).isSameOrBefore(
      moment(localEnd),
      'day'
    );

    this.setState({
      min: normalizedStart,
      max: normalizedEnd,
      dayStart: moment(localStart).date(),
      inputMonthStart: moment(localStart).month() + 1,
      monthStart: moment(localStart).month(),
      yearStart: moment(localStart).year(),
      dayEnd: moment(localEnd).date(),
      inputMonthEnd: moment(localEnd).month() + 1,
      monthEnd: moment(localEnd).month(),
      yearEnd: moment(localEnd).year(),
      startBeforeEnd: startBeforeEndBool
    });

    if (makeCall) {
      this.setTimePeriod(
        localStart,
        moment(localEnd)
          .add(1, 'days')
          .format('YYYY-MM-DD')
      );
    }
  };

  setStartDate = async () => {
    if (this.state.timeType != 1) return;

    await this.setState({
      min: moment({
        year: this.state.yearStart,
        month: this.state.monthStart,
        day: this.state.dayStart
      }).format('YYYY-MM-DD')
    });
  };

  setEndDate = async () => {
    if (this.state.timeType != 1) return;

    await this.setState({
      max: moment({
        year: this.state.yearEnd,
        month: this.state.monthEnd,
        day: this.state.dayEnd
      }).format('YYYY-MM-DD')
    });
  };

  getData = () => {
    let start = this.state.min;
    let end = moment(this.state.max).format('YYYY-MM-DD');

    if (start != 'Invalid date' && end != 'Invalid date')
      this.setTimePeriod(
        start,
        moment(end)
          .add(1, 'days')
          .format('YYYY-MM-DD')
      );
  };

  setTimePeriod = async (start, end) => {
    const normalizedStart = moment(start).format('YYYY-MM-DD');
    const normalizedEnd = moment(end).format('YYYY-MM-DD');
    if (
      normalizedStart === 'Invalid date' ||
      normalizedEnd === 'Invalid date'
    ) {
      return;
    }
    if (
      normalizedStart === this.props.queryStart &&
      normalizedEnd === this.props.queryEnd
    ) {
      return;
    }
    this.props.clearSelectedItem();
    this.props.clearEntireTrack();
    this.props.setStartEnd(normalizedStart, normalizedEnd);
    if (this.props.fetchAllData && this.props.fetchAllData.cancel) {
      this.props.fetchAllData.cancel();
    }
    this.props.fetchAllData({ refreshAlerts: true });
  };

  setMobilePreset = async e => {
    const value = e.target.value;
    this.setFixedTimePeriod(value);
  };

  setMobileStartDate = e => {
    const min = e.target.value;
    this.setState({ min }, () => {
      const localEnd = this.state.max || min;
      this.setRangedTimePeriod(min, localEnd, false);
    });
  };

  setMobileEndDate = e => {
    const max = e.target.value;
    this.setState({ max }, () => {
      const localStart = this.state.min || max;
      this.setRangedTimePeriod(localStart, max, false);
    });
  };

  applyMobileRange = () => {
    this.setState({ timeType: 1 }, () => this.getData());
  };

  render() {
    const startDateValue = this.state.min || '';
    const endDateValue = this.state.max || '';

    return (
      <div className="container-fluid">
        <div className="row search">
          <div className="col-12 border-bottom px-0 py-2">
            <div className="px-3">
              <form onSubmit={e => e.preventDefault()}>
                <div className="mobile-search-controls d-lg-none">
                  <input
                    value={this.state.searchTerm}
                    type="text"
                    placeholder="Search..."
                    className="form-control mobile-search-input"
                    aria-label="Search query"
                    onChange={e => this.search(e.target.value)}
                  />
                  <select
                    className={`custom-select mobile-search-preset ${
                      this.state.timeType == 0
                        ? 'period-mode-active'
                        : 'period-mode-dimmed'
                    }`}
                    onFocus={() => this.changeTimeType(0)}
                    onClick={() => this.changeTimeType(0)}
                    onChange={this.setMobilePreset}
                    value={this.state.standardTimeValue}
                  >
                    <option value={0}>Vandaag</option>
                    <option value={1}>Gisteren</option>
                    <option value={2}>Afgelopen 7 dagen</option>
                    <option value={3}>Deze maand</option>
                    <option value={4}>Vorige maand</option>
                    <option value={5}>Dit jaar</option>
                    <option value={6}>Vorig jaar</option>
                    <option value={7}>Alle data</option>
                  </select>
                  <div
                    className={`mobile-date-range ${
                      this.state.timeType == 1
                        ? 'period-mode-active'
                        : 'period-mode-dimmed'
                    }`}
                  >
                    <input
                      type="date"
                      className="form-control"
                      value={startDateValue}
                      max={endDateValue || undefined}
                      onFocus={() => this.changeTimeType(1)}
                      onClick={() => this.changeTimeType(1)}
                      onChange={this.setMobileStartDate}
                      aria-label="Start date"
                    />
                    <input
                      type="date"
                      className="form-control"
                      value={endDateValue}
                      min={startDateValue || undefined}
                      onFocus={() => this.changeTimeType(1)}
                      onClick={() => this.changeTimeType(1)}
                      onChange={this.setMobileEndDate}
                      aria-label="End date"
                    />
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      disabled={
                        !this.state.min ||
                        !this.state.max ||
                        !this.state.startBeforeEnd
                      }
                      onClick={this.applyMobileRange}
                    >
                      Toepassen
                    </button>
                  </div>
                </div>

                <div className="form-row align-items-center search-controls d-none d-lg-flex">
                  <div className="col-auto search-group search-group--query">
                    <div className="input-group border-right pr-3">
                      <input
                        value={this.state.searchTerm}
                        type="text"
                        placeholder="Search..."
                        className="form-control ml-1"
                        aria-label="Text input with dropdown button"
                        onSubmit={this.prevent}
                        onChange={e => this.search(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="mr-4 search-group search-group--fixed-toggle">
                    <label
                      className="form-check-label ml-2 mr-3"
                      htmlFor="fixedPeriod"
                    >
                      Selected period
                    </label>
                    <input
                      className="form-check-input ml-1"
                      type="radio"
                      name="exampleRadios"
                      id="fixedPeriod"
                      value={0}
                      checked={this.state.timeType == 0 ? true : false}
                      onChange={e => this.changeTimeType(e.target.value)}
                    />
                  </div>

                  <div
                    className={`col-auto pr-3 search-group search-group--fixed-select ${
                      this.state.timeType == 0
                        ? 'period-mode-active'
                        : 'period-mode-dimmed'
                    }`}
                  >
                    <label
                      className="sr-only "
                      htmlFor="inlineFormCustomSelect"
                    >
                      selected time period
                    </label>
                    <select
                      className="custom-select my-2"
                      id="inlineFormCustomSelect"
                      onFocus={() => this.changeTimeType(0)}
                      onClick={() => this.changeTimeType(0)}
                      onChange={e => this.setFixedTimePeriod(e.target.value)}
                      value={this.state.standardTimeValue}
                    >
                      <option value={0}>Today</option>
                      <option value={1}>Yesterday</option>
                      <option value={2}>Past 7 days</option>
                      <option value={3}>This month</option>
                      <option value={4}>Past month</option>
                      <option value={5}>This year</option>
                      <option value={6}>Past year</option>
                      <option value={7}>All data</option>
                    </select>
                  </div>

                  <div className="ml-4 search-group search-group--range-toggle">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="exampleRadios"
                      id="rangedPeriod"
                      value={1}
                      checked={this.state.timeType == 1 ? true : false}
                      onChange={e => this.changeTimeType(e.target.value)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="rangedPeriod"
                    ></label>
                  </div>

                  <div
                    className={`ml-1 pr-3 border-right search-group search-group--range-input ${
                      this.state.timeType == 1
                        ? 'period-mode-active'
                        : 'period-mode-dimmed'
                    }`}
                  >
                    <div style={appStyles}>
                      <div className="input-group align-items-center flex-nowrap">
                        <input
                          type="date"
                          value={startDateValue}
                          max={endDateValue || undefined}
                          className="form-control ml-1 date-range-picker-input"
                          aria-label="Start date"
                          onFocus={() => this.changeTimeType(1)}
                          onClick={() => this.changeTimeType(1)}
                          onChange={this.setMobileStartDate}
                        />
                        <span className="date-range_arrow" />
                        <input
                          type="date"
                          value={endDateValue}
                          min={startDateValue || undefined}
                          className="form-control ml-1 date-range-picker-input"
                          aria-label="End date"
                          onFocus={() => this.changeTimeType(1)}
                          onClick={() => this.changeTimeType(1)}
                          onChange={this.setMobileEndDate}
                        />
                        {!this.state.startBeforeEnd &&
                          this.state.timeType == 1 && (
                            <OverlayTrigger
                              overlay={
                                <Tooltip id="tooltip-disabled">
                                  End date before start date
                                </Tooltip>
                              }
                            >
                              <span className="exclamation-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-exclamation-triangle"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                                  <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
                                </svg>
                              </span>
                            </OverlayTrigger>
                          )}
                        <button
                          disabled={
                            this.state.timeType == 1 &&
                            this.state.min &&
                            this.state.max &&
                            this.state.startBeforeEnd
                              ? false
                              : true
                          }
                          type="button"
                          className="btn btn-primary btn-sm float-right ml-4"
                          onClick={e => {
                            if (this.state.timeType == 1) {
                              e.stopPropagation();
                              this.getData();
                            }
                          }}
                        >
                          Get data
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-auto ml-auto pr-2 d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm reset-all-filters-btn"
                      onClick={this.props.onResetAllFilters}
                    >
                      Reset all filters
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const getSearchQuery = state => state.query.searchQuery;
const getQueryStart = state => state.query.start;
const getQueryEnd = state => state.query.end;

const mapStateToProps = createSelector(
  getSearchQuery,
  getQueryStart,
  getQueryEnd,
  (searchQuery, queryStart, queryEnd) => ({
    searchQuery,
    queryStart,
    queryEnd
  })
);

const mapDispatchToProps = {
  setSearchQuery: actions.query.setSearchQuery,
  getTimeline: actions.timeline.getTimeline,
  setStartEnd: actions.query.setStartEnd,
  clearSelectedItem: actions.timeline.clearSelectedItem,
  clearEntireTrack: actions.layer.clearEntireTrack
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);
